import { h, Component } from "preact";

import { ThemeProvider } from "@material-ui/styles";
import theme from "../theme";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Home2 from "../components/Home2";
import Search from "../components/Search";
import Login from "../components/Login";
import DevenirAmbassadeur from "../components/DevenirAmbassadeur";
import VendreMonBien from "../components/VendreMonBien";
import AcheterViteUnBien from "../components/AcheterViteUnBien";
import Inscription from "../components/Inscription";
import LostPwd from "../components/LostPwd";
import InscriptionVendeur from "../components/InscriptionVendeur";
import InscriptionAmbassadeur from "../components/InscriptionAmbassadeur";
import MentionsLegales from "../components/MentionsLegales";
import CGV from "../components/CGV";
import CGU from "../components/CGU";
import UserDashboard from "../components/UserDashboard";
import Dataroom from "../components/Dataroom";
import Contact from "../components/Contact";

const SwitchComponent = (props) => {
	//console.log("switchComponent", props);
	switch (props.path) {
		case "/old":
			return <Home2 />;
			break;
		case "/trouver-un-bien-a-paris-a8e41f":
			return <Search />;
			break;
		case "/login":
			return <Login />;
			break;
		case "/devenir-ambassadeur":
			return <DevenirAmbassadeur />;
			break;
		case "/vendre-mon-bien":
			return <VendreMonBien />;
			break;
		case "/acheter-vite-un-bien":
			return <AcheterViteUnBien />;
			break;
		case "/inscription":
			return <Inscription />;
			break;
		case "/reinitialisation-du-mot-de-passe":
			return <LostPwd />;
			break;
		case "/dvenir-vendeur":
			return <InscriptionVendeur />;
			break;
		case "/devenir-ambassadeur":
			return <InscriptionAmbassadeur />;
			break;
		case "/mentions-legales":
			return <MentionsLegales />;
			break;
		case "/cgv":
			return <CGV />;
			break;
		case "/cgu":
			return <CGU />;
			break;
		case "/contact":
			return <Contact />;
			break;
		case "/dashboard":
			return <UserDashboard />;
			break;
		case "/dataroom":
			return <Dataroom />;
			break;
	}
};

export default class WithMainTheme extends Component {
	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */

	// handleRoute = async (e) => {
	// 	switch (e.url) {
	// 		case "/profile":
	// 			const isAuthed = await this.isAuthenticated();
	// 			if (!isAuthed) route("/", true);
	// 			break;
	// 	}
	// };

	render(props) {
		console.log(props);
		return (
			<ThemeProvider theme={theme}>
				<Header />
				<SwitchComponent path={props.path} />
				<Footer />
			</ThemeProvider>
		);
	}
}
